import {sendEvent} from '@github-ui/hydro-analytics'

const HASH_PATTERN = /-[0-9a-f]{16}\.(js|(?:module\.)?css)$/

function extractFilename(url: string): string {
  return url.split('/').pop() ?? url
}

function stripHash(filename: string): string {
  return filename.replace(HASH_PATTERN, '.$1')
}

function isCached(entry: PerformanceResourceTiming): boolean {
  return entry.transferSize === 0 && entry.decodedBodySize > 0
}

function downloadTime(entry: PerformanceResourceTiming): number {
  if (isCached(entry)) return 0
  return entry.responseEnd - entry.responseStart
}

function bundleType(entry: PerformanceResourceTiming): 'js' | 'css' | null {
  if (entry.initiatorType === 'script' && entry.name.endsWith('.js')) return 'js'
  if (entry.initiatorType === 'link' && entry.name.endsWith('.css')) return 'css'
  return null
}

export function observeBundleStats(): void {
  if (typeof PerformanceObserver === 'undefined') return

  const observer = new PerformanceObserver(list => {
    for (const entry of list.getEntries() as PerformanceResourceTiming[]) {
      const type = bundleType(entry)
      if (!type) continue

      const filename = extractFilename(entry.name)

      sendEvent(
        'bundle-stats',
        {
          type,
          name: filename,
          nameWithoutHash: stripHash(filename),
          cached: isCached(entry),
          downloadMs: Math.round(downloadTime(entry) * 100) / 100,
          sizeBytes: entry.decodedBodySize,
          compressedSizeBytes: entry.encodedBodySize,
        },
        {
          batched: true,
        },
      )
    }
  })

  observer.observe({type: 'resource', buffered: true})
}
